module.exports = __webpack_public_path__ + "static/media/suggestedToFriends_15_25.f573ac3f.png";